import { Button } from '@novaquantis/design-system';
import OnboardingEtfNotice from '../../../components/onboarding/OnboardingEtfNotice';
import OnboardingInfoBox from '../../../components/onboarding/OnboardingInfoBox';
import OnboardingStepActions from '../../../components/onboarding/OnboardingStepActions';
import { ALPACA_LINKS } from '../../../onboarding/onboardingSteps';
import {
  stepTitleClass,
  stepLeadClass,
  stepBodyClass,
  stepListClass,
  stepFootnoteClass,
  stepLinkSecondaryClass,
} from './stepStyles';

type Props = {
  onContinue: () => void;
  continuing: boolean;
};

const WelcomeStep = ({ onContinue, continuing }: Props) => (
  <div>
    <h1 className={stepTitleClass}>Welcome to NovaQuantis</h1>
    <p className={stepLeadClass}>
      This short guided setup will help you connect your Alpaca brokerage account so you
      can view and manage your portfolio in NovaQuantis.
    </p>
    <OnboardingInfoBox variant="gold" title="Important">
      NovaQuantis is not currently registered as a Registered Investment Adviser (RIA).
      Until that registration is complete, we cannot perform identity verification (KYC)
      inside this application. You will complete KYC directly with Alpaca, our brokerage
      partner.
    </OnboardingInfoBox>
    <OnboardingEtfNotice />
    <p className={stepBodyClass}>What to expect in the next steps:</p>
    <ul className={stepListClass}>
      <li>Create an individual trading account at Alpaca</li>
      <li>Complete Alpaca&apos;s identity verification</li>
      <li>Generate API keys in the Alpaca dashboard</li>
      <li>Connect your keys securely to NovaQuantis</li>
    </ul>
    <p className={stepFootnoteClass}>
      Learn more about Alpaca:{' '}
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.registerGuide}
        target="_blank"
        rel="noopener noreferrer"
      >
        Alpaca registration overview
      </a>
    </p>
    <OnboardingStepActions>
      <Button type="button" onClick={onContinue} disabled={continuing} variant="glow">
        {continuing ? 'Saving…' : 'Continue'}
      </Button>
    </OnboardingStepActions>
  </div>
);

export default WelcomeStep;
